import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import VueAnalytics from 'vue-analytics'

import App from './App.vue';
import QuestionGenerator from './services/QuestionGenerator';
import { routes } from "./routes";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(QuestionGenerator);
Vue.use(VueRouter);
Vue.use(VueAnalytics, {
    id: 'UA-126638609-4',
    disableScriptLoader: true,
});

const router = new VueRouter({
    routes,
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
